/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import { IconButton, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import { engagementTableResponse } from "../../api/table-response";
import WishListEditor from "./WishListEditor";
import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_WISH_LIST, EXPORT_WISH_LIST, GET_ALL_WISH_LIST } from "../../../../shared/api/endpoints.js";

const WishLists = () => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  const { hasMore, loading, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_WISH_LIST,
      filter,
      true,
      refreshData,
      sumbitSearch, 1, false, engagementTableResponse
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title="مورد علاقه ها"
        broadCrumb={[
          {
            title: " غرفه و کاربران",
            path: "/booth",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
           
                <Exports
                  sumbitSearch={sumbitSearch}
                  filter={filter}
                  header={header}
                  data={allData}
                  selectedData={selected}
                  title="مورد علاقه ها"
                  api={EXPORT_WISH_LIST}
                />
        

              {/*           <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن مورد علاقه جدید
              </Button> */}
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_WISH_LIST}
          title="مورد علاقه ها"
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <WishListEditor open={openEdit} data={editingData} close={() => { setOpenEdit(false); setEditingData({}); }}
        onSaved={() => setRefresh((value) => value + 1)} />
      {/*      <BoothModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      /> */}
    </>
  );
};

export default WishLists;
